module.exports = __webpack_public_path__ + "static/5-809c5ee83f24b26a10028b4c3775e0ad.jpg";